export default __webpack_public_path__ + "static/media/ghost.e07e8579.png";